export enum ScreenOrientation {
  Landscape = 'landscape',
  Portrait = 'portrait',
}
